import http, { apiErrorMessage } from "../../http";

const postLogin = (dispatch, credentials, actionType) => {
  dispatch({ type: "LOGIN_LOADING" });

  http
    .post("auth/login", {
      usuario: credentials.user,
      password: credentials.password
    })
    .then(function(response) {
      // Envelope v1: {data:{token,idUsuario,nombreUsuario,...}}
      const data = response.data.data;
      dispatch({
        type: actionType + "_SUCCESS",
        payload: {
          accessToken: data.token,
          userId: data.idUsuario,
          user: credentials.user,
          userFullName: data.nombreUsuario,
          sucursal: data.sucursal,
          nombresucursal: data.nombresucursal,
          puesto: data.puesto,
          puestoDescripcion: data.puestoDescripcion,
          foto: data.foto
        }
      });
    })
    .catch(function(error) {
      dispatch({
        type: actionType + "_ERROR",
        payload: { error: apiErrorMessage(error) }
      });
    })
    .finally(function() {
    });
};

export const cambiarsucursal = (idsucursal, nombresucursal) => {
  return (dispatch, getState) => {
    dispatch({
      type: "CAMBIO_SUCURSAL",
      payload: {
        sucursal: idsucursal,
        nombresucursal: nombresucursal
      }
    });
  };
};

export const login = credentials => {
  return (dispatch, getState) => {
    postLogin(dispatch, credentials, "LOGIN");
  };
};

export const logout = () => {
  return (dispatch, getState) => {
    dispatch({ type: "LOGOUT_SUCCESS" });
  };
};

export const lock = () => {
  return (dispatch, getState) => {
    dispatch({ type: "LOCK_SUCCESS" });
  };
};

export const unlock = credentials => {
  return (dispatch, getstate) => {
    postLogin(dispatch, credentials, "UNLOCK");
  };
};
